import type { Ref } from 'react';
import type { HTMLAttributes, ReactNode } from 'react';
import { cx } from '../lib/cx';

export type CalloutTone = 'success' | 'error' | 'warning' | 'info';

export interface CalloutProps extends Omit<HTMLAttributes<HTMLDivElement>, 'title'> {
  tone?: CalloutTone;

  note?: boolean;
  icon?: ReactNode;

  title?: ReactNode;
  titleLang?: string;
  titleDir?: 'ltr' | 'rtl' | 'auto';
}

export function Callout(
  { ref, tone = 'info', note = false, icon, title, titleLang, titleDir, className, children, ...rest }: CalloutProps & { ref?: Ref<HTMLDivElement> },
) {
  return (
    <div
      ref={ref}
      className={cx(
        'callout',
        icon != null && 'callout--icon',
        note && 'callout--note',
        `is-${tone}`,
        className,
      )}
      {...rest}
    >
      {icon}
      {title != null ? (
        <span className="callout-body">
          <strong className="callout-title" lang={titleLang} dir={titleDir}>
            {title}
          </strong>
          {children != null && <span className="callout-detail">{children}</span>}
        </span>
      ) : (
        children
      )}
    </div>
  );
}
